import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function PremiumPopup() {
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const hiddenUntil = localStorage.getItem("premiumPopupHiddenUntil");
        if (!hiddenUntil || Date.now() > Number(hiddenUntil)) {
            setVisible(true);
        }
    }, []);

    const handleClose = () => setVisible(false);

    const handleHideToday = () => {
        const midnight = new Date();
        midnight.setHours(23, 59, 59, 999);
        localStorage.setItem("premiumPopupHiddenUntil", String(midnight.getTime()));
        setVisible(false);
    };

    const handleGoToPremium = () => {
        navigate("/premium");
    };

    if (!visible) return null;

    return (
        <div className="premium-popup-overlay" onClick={handleClose}>
            <div className="premium-popup-card" onClick={(e) => e.stopPropagation()}>
                <div className="premium-popup-header">
                    <span className="premium-popup-badge">NEW</span>
                    <h2 className="premium-popup-title">프리미엄 채용관 오픈!</h2>
                    <p className="premium-popup-subtitle">GA 전문 인력 채용의 새로운 기준</p>
                </div>

                <div className="premium-popup-body">
                    <p className="premium-popup-desc">
                        라이징브로커즈의 <strong>프리미엄 채용관</strong>에서<br />
                        GA 업계 최고 인재와 기업을 연결합니다.
                    </p>
                    <ul className="premium-popup-features">
                        <li> 1. 총무·설계사·교육 매니저 등 전문직종 채용</li>
                        <li> 2. 전국 지역별 채용 공고 한눈에 확인</li>
                        <li> 3. GA 업계 특화 매칭 서비스</li>
                    </ul>
                    <button className="premium-popup-cta" onClick={handleGoToPremium}>
                        프리미엄 채용관 바로가기
                    </button>
                </div>

                <div className="premium-popup-footer">
                    <button className="premium-popup-hide-today" onClick={handleHideToday}>
                        오늘 하루 보지 않기
                    </button>
                    <button className="premium-popup-close" onClick={handleClose}>
                        닫기
                    </button>
                </div>

                <style jsx>{`
                    .premium-popup-overlay {
                        position: fixed;
                        inset: 0;
                        background: rgba(0, 0, 0, 0.55);
                        z-index: 9000;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        animation: overlayFadeIn 0.25s ease;
                    }

                    @keyframes overlayFadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }

                    .premium-popup-card {
                        width: 100%;
                        max-width: 480px;
                        background: #fff;
                        border-radius: 20px;
                        overflow: hidden;
                        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
                        animation: cardSlideUp 0.3s ease;
                        margin: 0 16px;
                    }

                    @keyframes cardSlideUp {
                        from { opacity: 0; transform: translateY(24px); }
                        to { opacity: 1; transform: translateY(0); }
                    }

                    .premium-popup-header {
                        background: linear-gradient(135deg, #fd7314 0%, #f1863f 100%);
                        padding: 32px 32px 28px;
                        text-align: center;
                        position: relative;
                    }

                    .premium-popup-badge {
                        display: inline-block;
                        background: #f1f034;
                        color: #1c1814;
                        font-size: 0.7rem;
                        font-weight: 800;
                        letter-spacing: 0.15em;
                        padding: 3px 10px;
                        border-radius: 999px;
                        margin-bottom: 12px;
                    }

                    .premium-popup-title {
                        font-size: 1.8rem;
                        font-weight: 800;
                        color: #fff;
                        margin: 0 0 8px;
                        line-height: 1.3;
                    }

                    .premium-popup-subtitle {
                        font-size: 0.95rem;
                        color: rgba(255, 255, 255, 0.88);
                        margin: 0;
                    }

                    .premium-popup-body {
                        padding: 28px 32px 20px;
                    }

                    .premium-popup-desc {
                        font-size: 1rem;
                        color: #444;
                        line-height: 1.7;
                        margin: 0 0 18px;
                        text-align: center;
                    }

                    .premium-popup-desc strong {
                        color: #f16102;
                    }

                    .premium-popup-features {
                        list-style: none;
                        padding: 0;
                        margin: 0 0 24px;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }

                    .premium-popup-features li {
                        font-size: 0.92rem;
                        color: #555;
                        background: #fdf5ef;
                        text-align: left;
                        border-left: 3px solid #f16102;
                        padding: 10px 14px;
                        border-radius: 6px;
                        line-height: 1.4;
                    }

                    .premium-popup-cta {
                        width: 100%;
                        background: linear-gradient(135deg, #fd7314 0%, #f1863f 100%);
                        color: #fff;
                        border: none;
                        border-radius: 12px;
                        padding: 16px;
                        font-size: 1.05rem;
                        font-weight: 700;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        letter-spacing: 0.02em;
                    }

                    .premium-popup-cta:hover {
                        background: linear-gradient(135deg, #e6670e 0%, #d9732e 100%);
                        transform: translateY(-1px);
                        box-shadow: 0 6px 20px rgba(253, 115, 20, 0.35);
                    }

                    .premium-popup-footer {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 14px 32px 20px;
                        border-top: 1px solid #f0ece8;
                    }

                    .premium-popup-hide-today {
                        background: none;
                        border: none;
                        font-size: 0.82rem;
                        color: #999;
                        cursor: pointer;
                        padding: 4px 0;
                        text-decoration: underline;
                        text-underline-offset: 3px;
                    }

                    .premium-popup-hide-today:hover {
                        color: #666;
                    }

                    .premium-popup-close {
                        background: none;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        font-size: 0.85rem;
                        color: #555;
                        cursor: pointer;
                        padding: 6px 16px;
                        transition: all 0.15s ease;
                    }

                    .premium-popup-close:hover {
                        background: #f5f5f5;
                        border-color: #bbb;
                    }

                    @media (max-width: 480px) {
                        .premium-popup-overlay {
                            align-items: flex-end;
                        }

                        .premium-popup-card {
                            max-width: 100%;
                            margin: 0;
                            border-radius: 20px 20px 0 0;
                            animation: cardSlideUpMobile 0.3s ease;
                        }

                        @keyframes cardSlideUpMobile {
                            from { opacity: 0; transform: translateY(100%); }
                            to { opacity: 1; transform: translateY(0); }
                        }

                        .premium-popup-header {
                            padding: 20px 20px 16px;
                        }

                        .premium-popup-badge {
                            margin-bottom: 8px;
                        }

                        .premium-popup-title {
                            font-size: 1.4rem;
                        }

                        .premium-popup-subtitle {
                            font-size: 0.85rem;
                        }

                        .premium-popup-body {
                            padding: 18px 20px 14px;
                        }

                        .premium-popup-desc {
                            font-size: 0.9rem;
                            margin-bottom: 14px;
                        }

                        .premium-popup-features {
                            gap: 8px;
                            margin-bottom: 16px;
                        }

                        .premium-popup-features li {
                            font-size: 0.85rem;
                            padding: 8px 12px;
                        }

                        .premium-popup-cta {
                            padding: 14px;
                            font-size: 0.95rem;
                        }

                        .premium-popup-footer {
                            padding: 12px 20px 28px;
                        }

                        .premium-popup-hide-today {
                            font-size: 0.78rem;
                        }

                        .premium-popup-close {
                            font-size: 0.8rem;
                            padding: 6px 14px;
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}
